{
  "min": -10,
  "max": 110,
  "R": [0, 199, 255],
  "G": [0, 127, 255],
  "B": [0, 127, 255],
  "A": [0, 48, 128],
  "I": [0, 124, 255]
}
